import React from 'react';
import Button from '../Button/Button';
import styles from './StudentNotesStudentInfo.module.css';

interface StudentNotesStudentInfoProps {
  studentName: string;
  showGenerateSummary?: boolean;
  generatingSummary?: boolean;
  generateDisabled?: boolean;
  onGenerateSummary?: () => void;
}

const StudentNotesStudentInfo: React.FC<StudentNotesStudentInfoProps> = ({
  studentName,
  showGenerateSummary = false,
  generatingSummary = false,
  generateDisabled = false,
  onGenerateSummary,
}) => (
  <div className={styles.studentRow}>
    <div className={styles.studentInfo}>
      <span className={styles.studentLabel}>Aluna</span>
      <span className={styles.studentName}>{studentName || '—'}</span>
    </div>
    {showGenerateSummary && onGenerateSummary && (
      <Button
        type="button"
        variant="outline"
        size="small"
        icon="auto_awesome"
        className={[
          styles.generateButton,
          generatingSummary ? styles.generateButtonGenerating : '',
        ].filter(Boolean).join(' ')}
        disabled={generateDisabled || generatingSummary}
        aria-busy={generatingSummary}
        onClick={onGenerateSummary}
      >
        Gerar resumo
      </Button>
    )}
  </div>
);

export default StudentNotesStudentInfo;
